import { inject, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SharedSignalService {
    private readonly currentTheme = signal('light');

    constructor() { }


    getTheme(): string {
        return this.currentTheme();
    }

    setTheme(theme: string): void {
        this.currentTheme.set(theme);
    }


}